import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-select-email-addresses-modal',
  templateUrl: './modal-select-email-addresses.component.html',
  styleUrls: ['./modal-select-email-addresses.component.scss'],
})
export class SelectEmailAddressesModalComponent implements OnInit {
  selectEmailAddressesForm;

  constructor(private dialogRef: MatDialogRef<SelectEmailAddressesModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: UntypedFormBuilder) {}

  private getControlsConfig() {
    return {
      selectedEmailAddresses: [],
    };
  }

  ngOnInit(): void {
    this.selectEmailAddressesForm = this.formBuilder.group(this.getControlsConfig());
  }

  close(isSubmit: boolean) {
    this.dialogRef.close({ isSubmit, emailAddresses: this.selectEmailAddressesForm.value.selectedEmailAddresses });
  }
}
